/**
 * Log Configuration
 * Controls console logging in all environments
 *
 * Logs are DISABLED by default unless REACT_APP_ENABLE_LOGS=true is set
 * This prevents accidental log exposure in production/test environments
 */

// Enable logs ONLY if explicitly set to 'true'
// If undefined or any other value, logs are disabled
export const enableLogs = process.env.REACT_APP_ENABLE_LOGS === 'true';

/**
 * Initialize log override
 * Call this once at app startup to disable console.log in production
 */
export const initializeLogConfig = () => {
    if (!enableLogs) {
        // Save original console methods
        const originalConsoleLog = console.log;
        const originalConsoleDebug = console.debug;
        const originalConsoleInfo = console.info;

        // Override console.log and related methods
        console.log = () => {};
        console.debug = () => {};
        console.info = () => {};

        // Keep console.warn and console.error active for production debugging
        // console.warn and console.error are NOT disabled

        // Optional: Add a way to restore logs for debugging in production
        (window as any).__enableLogs = () => {
            console.log = originalConsoleLog;
            console.debug = originalConsoleDebug;
            console.info = originalConsoleInfo;
            console.log('Logs enabled!');
        };
    }
};
